/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { isEmpty } from '@ember/utils';
import { DataSourceLabelVariant } from 'cio/utils/data-source-label';

interface CioConditionViewerAttributeValueArgs {
  value: string | null;
  showBlank: boolean;
  shouldFormatTimestamp: boolean;
  labelVariant?: DataSourceLabelVariant;
  labelTruncate?: boolean;
  labelClasses?: string;
}

export default class CioConditionViewerAttributeValue extends Component<CioConditionViewerAttributeValueArgs> {
  get hasValue() {
    return !isEmpty(this.args.value);
  }
}
